import {Menu} from '@dropbox/dig-components/menu';
import {UIIcon} from '@dropbox/dig-icons';
import {DeleteLine, EditLine, OpenLine} from '@dropbox/dig-icons/assets';
import {t} from 'i18next';

import {WorkstreamRoadmapChip} from './WorkstreamRoadmapChip';

export const WorkstreamRoadmapMenu = ({
  disabled,
  onOpen,
  onEdit,
  onRemove,
}: {
  disabled: boolean;
  onOpen: () => void;
  onEdit: () => void;
  onRemove?: () => void;
}) => (
  <Menu.Wrapper shouldPropagateClickOutsideMouseEvents>
    {({getContentProps, getTriggerProps}) => (
      <>
        <WorkstreamRoadmapChip {...getTriggerProps()} disabled={disabled} />
        <Menu.Content {...getContentProps()} placement="bottom-start">
          <Menu.Segment>
            <Menu.ActionItem
              withLeftAccessory={<UIIcon src={OpenLine} size="small" />}
              onClick={onOpen}
            >
              {t('open')}
            </Menu.ActionItem>
            <Menu.ActionItem
              withLeftAccessory={<UIIcon src={EditLine} size="small" />}
              onClick={onEdit}
            >
              {t('workstream_product_roadmap_edit_link')}
            </Menu.ActionItem>
            {onRemove && (
              <Menu.ActionItem
                withLeftAccessory={<UIIcon src={DeleteLine} size="small" />}
                onClick={onRemove}
              >
                {t('remove')}
              </Menu.ActionItem>
            )}
          </Menu.Segment>
        </Menu.Content>
      </>
    )}
  </Menu.Wrapper>
);
